<template>
  <Modal
    :modal="modal"
    :titleIcons="[]"
    title="Informe o Telefone"
    @close="$emit('close')"
    @save="save"
    :loading="loading"
  >
    <v-form v-model="valid" ref="form">
      <v-autocomplete
        v-model="clienteTelefone.tipo_telefone"
        :items="tiposTelefone"
        item-text="descricao"
        label="Tipo"
        no-data-text="Nenhum registro encontrado"
      ></v-autocomplete>
      <v-text-field
        v-model="clienteTelefone.telefone"
        label="Telefone"
        :autofocus="modal"
        :rules="[rules.required]"
      ></v-text-field>
      <v-text-field
        v-model="clienteTelefone.contato"
        label="Contato"
        :rules="[rules.required]"
    ></v-text-field>
    </v-form>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/shared/Modal';
import ClienteTelefone from '@/domain/ClienteTelefone';

export default {
  name: 'ModalClienteTelefone',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    editClienteTelefone: {
      type: Object,
      default: null
    }
  },
  components: {
    Modal
  },
  data: () => ({
    loading: false,
    valid: true,
    clienteTelefone: new ClienteTelefone(),
    rules: {
      required: v => !!v || 'Campo obrigatório'
    }
  }),
  watch: {
    modal(value) {
      if (!value) this.clienteTelefone = new ClienteTelefone();
    },
    editClienteTelefone(value) {
      if (value) this.clienteTelefone = value;
    }
  },
  computed: {
    ...mapGetters(['tiposTelefone'])
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        if (!this.editClienteTelefone) {
          this.$emit('save', this.clienteTelefone);
        } else {
          this.$emit('update', this.clienteTelefone);
        }
      }
    }
  }
}
</script>

<style>

</style>